import firestore from "../../../firebase/firestore";

export default {
  getBillingReports({ state, commit }) {
    try {
      commit("resetState");
      commit("setLoading", true);

      const reportsRef = firestore.collection("billing_reports");

      return reportsRef.onSnapshot((res) => {
        if (res.size > 0) {
          const changes = res.docChanges();
          changes.forEach((change) => {
            const { doc } = change;
            switch (change.type) {
              case "added": {
                const data = {
                  ...doc.data(),
                  id: doc.id,
                };
                commit("pushBillingReport", data);
                break;
              }
              case "modified": {
                const data = {
                  id: doc.id,
                  ...doc.data(),
                };
                const index = state.holidays.findIndex((i) => i.id === doc.id);
                commit("spliceBillingReports", { index, data });
                break;
              }
              case "removed": {
                const new_reports = state.holidays.filter(
                  (i) => i.id !== doc.id,
                );
                commit("setBillingReports", new_reports);
                break;
              }
              default:
                break;
            }
          });
          commit("setLoading", false);
          return 200;
        } else {
          commit("setLoading", false);
          return 404;
        }
      });
    } catch (err) {
      commit("setLoading", false);
      return 500;
    }
  },
};
